import axios from 'axios';
import config from '../config/env-constants';

export default {

    createFaq(params, currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/createFaq`;
        return axios.post(url, {
            currUserId,
            ...params
        });
    },

    updateFaq(params, currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/updateFaq`;
        return axios.post(url, {
            currUserId,
            ...params
        });
    }
}